'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyBindingFn = require('./keyBindingFn');

var _keyBindingFn2 = _interopRequireDefault(_keyBindingFn);

var _handleKeyCommand = require('./handleKeyCommand');

var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Requires the props:
 *  - saveCurrentContent, and
 *  - emptyDelete
 */
exports.default = function () {
  return {
    keyBindingFn: _keyBindingFn2.default,
    handleKeyCommand: _handleKeyCommand2.default
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/deleteOnEmpty/index.js
// module id = 684
// module chunks = 0